module.exports = __webpack_public_path__ + "1e65d345.svg";